export var CalendarStrings = {
    groupOrderEntry: {
        checkoutAvailable: {
            checkoutButton: function () { return 'Checkout'; },
            employeeOrderBy: function () { return 'Order by'; },
            adminCheckoutBy: function () { return 'Check out by'; },
            joinGroupCartButton: function () { return 'Join Group Order'; },
            joinGroupCartButtonMobileView: function () { return 'Join'; },
            infoTooltip: function (deliveryTime) {
                return "To get your order delivered by " + deliveryTime;
            },
        },
        cartCreated: {
            availableAt: function () { return 'Available at'; },
        },
        trackOrder: {
            estimatedDeliveryTime: function () { return 'Estimated delivery time'; },
            trackOrderButton: function () { return 'Track Order'; },
        },
        completedOrder: {
            viewReceipt: function () { return 'View Receipt'; },
            completed: function () { return 'Completed'; },
        },
        cancelledOrder: {
            cancelled: function () { return 'Cancelled'; },
        },
        spendingLimitPerPerson: function () { return 'per person'; },
        imageComingSoon: function () { return 'Image coming soon'; },
    },
    deleteConfirmationModal: {
        title: function () { return 'Are you sure you want to cancel this Group Order?'; },
        content: function () { return 'All items added by your group will be removed.'; },
        goBackButton: function () { return 'Go Back'; },
        cancelOrderButton: function () { return 'Cancel Order'; },
    },
    showWeekendsLabel: function () { return 'Show weekends'; },
};
